import React from 'react';
import GettingStarted from './guide/getting-started';
import SideBar from './guide/SideBar.js';

function Guide() {
    return (
        <>
            <GettingStarted />
        </>
    );
}

Guide.Layout = SideBar;

export default Guide;
